import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/components/_infobox.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem('infobox', styles);
var Infobox = function Infobox(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      extraClasses = _ref.extraClasses,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "extraClasses"]);

  return React.createElement("div", _extends({
    className: bem.b(appearance, extraClasses)
  }, rest), React.createElement("div", {
    className: bem.e('content')
  }, children));
};
Infobox.displayName = 'Infobox';
Infobox.defaultProps = {
  appearance: null,
  extraClasses: ''
};
Infobox.propTypes = {
  /** Set appearance of the infobox */
  appearance: PropTypes.oneOf([null, 'success', 'warning', 'danger']),

  /** Content of the infobox */
  children: PropTypes.node.isRequired,

  /** Injection in className */
  extraClasses: PropTypes.string
};
var infobox = Injecss(Infobox, styles);

export default infobox;
export { Infobox };
